export default function initautocomplete(){
    var searchInput = $(".metanav form input[type=text],.module-search input[type=text], .searchbox .box input[type=text], .cc-footer__searchbar input[type=text]");

    searchInput.attr("autocomplete", "off");

    var autoComplete = $('<div class="autocomplete-dropdown"></div>');
    searchInput.parents(".searchform,.input-group,.searchbox .box").append(autoComplete);

    searchInput.parents("form").on("click touchend", ".autocomplete-dropdown .autocomplete-suggestion", function () {
        $(this).parents("form").find("input[type=text]").val($(this).text());
        $(this).parents("form").submit();
    });

    searchInput.on("input", function () {
        var input = $(this);
        var autoComplete = input.closest("form,.input-group").find(".autocomplete-dropdown");
        if (input.val().length >= 3) {
            $.ajax({
                url: location.href.indexOf("/rezepte/") !== -1 ? "/autocomplete.json" : "autocomplete.json",
                data: {
                    method: "post",
                    query: input.val(),
                    type: input.hasClass("recipesearch") ? "recipe" : "portal"
                }
            }).done(function (resJson) {

                if (resJson["portal"] !== undefined) {
                    var rawSuggestions = resJson["portal"]["facet_counts"]["facet_fields"]["autocomplete"];

                }
                else {
                    var rawSuggestions = []
                }
                rawSuggestions = rawSuggestions.concat(resJson["recipes"]["facet_counts"]["facet_fields"]["autocomplete"]);

                autoComplete.children().remove();
                var res = resJson;
                if (rawSuggestions.length > 0) {
                    autoComplete.show();

                    var uniqueSuggestions = [];

                    var suggestions = rawSuggestions.filter(
                        function (item, index) {
                            return item !== input.val() && index % 2 == 0;
                        }
                    );

                    for (var x = 0; x < suggestions.length; x++) {
                        if (uniqueSuggestions.indexOf(suggestions[x]) === -1) {
                            uniqueSuggestions.push(suggestions[x]);
                        }
                    }

                    uniqueSuggestions.sort();

                    uniqueSuggestions.map(function (val) {
                        var hitspan = val.replace(input.val().toLowerCase(), '<span class="hit">' + input.val() + '</span>');
                        var newSuggestion = $('<div class="autocomplete-suggestion"><a>' + hitspan + '</a></div>');
                        autoComplete.append(newSuggestion);
                        return newSuggestion;
                    }, this);
                    input.closest("form,.input-group,.box").append(autoComplete);
                }
                else {
                    autoComplete.hide();
                }
            });
        }
        else {
            autoComplete.hide();
            autoComplete.children().remove();

        }
    });
    $("body").on("click", function () {
        $(".autocomplete-dropdown").each(function () {
            $(this).children().remove();
            $(this).hide();
        });
    });
    searchInput.on("keydown", function (e) {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();
        }

        var dropdown = $(this).siblings(".autocomplete-dropdown");
        var suggestions = dropdown.find(".autocomplete-suggestion");
        var focus = suggestions.filter(".focus");

        if (e.key === "Enter" && focus.length > 0) {
            e.preventDefault();
            $(this).val(focus.text());
            $(this).closest("form").submit();
        }
        if (e.key === "ArrowDown") {
            if (suggestions.length > 0 && focus.length === 0) {
                suggestions.first().addClass("focus");
            }
            else {
                if (focus.next().length > 0) {
                    focus.removeClass("focus").next().addClass("focus");
                }
            }
        }
        else if (e.key === "ArrowUp") {
            if (focus.prev().length > 0) {
                focus.removeClass("focus").prev().addClass("focus");
            }
        }
    });

    $("input[type=hidden][name=t]").val(Date.now() + Math.random().toString().replace("0.", ""));
}

